import {IRouteStore} from '../../../router/routing.infra';
import {getDashboardStores} from '../dashboard.stores';
import {IRedirectToStoreController} from './redirectToStore.controller';

export interface IRedirectToStoreStore extends IRouteStore {
    redirectToStoreController: IRedirectToStoreController;
}

export class RedirectToStoreStore implements IRedirectToStoreStore {
    public redirectToStoreController: IRedirectToStoreController;

    constructor() {
        const dashboardStores = getDashboardStores();
        this.redirectToStoreController = dashboardStores.dashboardMainController.redirectToStoreController;
    }

    dispose(): void {
        // Controller disposal is handled by DashboardStores.dispose()
    }
}
